var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "carousel carousel-animated carousel-animate-slide",
        class: { "is-loading-image-popup": _vm.isLoading },
      },
      [
        _vm.isLoading && !_vm.imageBase64
          ? _c("section", { staticClass: "section" }, [_vm._m(0)])
          : _vm._e(),
        _c("div", { staticClass: "carousel-container" }, [
          _vm._m(1),
          _c(
            "div",
            {
              staticClass: "carousel-item has-background",
              staticStyle: { overflow: "visible" },
            },
            [
              _c("div", { attrs: { id: "img-zoomer-box" } }, [
                _c("img", {
                  staticClass: "is-background",
                  attrs: {
                    id: "img-1",
                    src: _vm.imageBase64,
                    alt: "",
                    width: "800",
                    height: "600",
                  },
                  on: {
                    mousemove: _vm.handleMouseOver,
                    mouseleave: function ($event) {
                      _vm.showZoom = false
                    },
                    click: _vm.handleImageClick,
                  },
                }),
                _vm.showZoom
                  ? _c("div", { attrs: { id: "img-2" } }, [
                      _c("div", { attrs: { id: "img-2-bg" } }),
                    ])
                  : _vm._e(),
              ]),
              _vm.imageBase64
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(_vm.imageIndex + 1) +
                        " of " +
                        _vm._s(_vm.imageCount)
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
        _c("div", { staticClass: "carousel-navigation is-overlay" }, [
          _c("div", { staticClass: "carousel-nav-left" }, [
            _c("i", {
              staticClass: "mdi mdi-36px mdi-chevron-left",
              class: {
                "mdi-inactive-color mdi-inactive": _vm.imageIndex === 0,
              },
              attrs: { "aria-hidden": "true" },
              on: {
                click: function ($event) {
                  return _vm.previousImage()
                },
              },
            }),
          ]),
          _c("div", { staticClass: "carousel-nav-right" }, [
            _c("i", {
              staticClass: "mdi mdi-36px mdi-chevron-right",
              class: {
                "mdi-inactive-color mdi-inactive":
                  _vm.imageIndex === _vm.imageCount - 1,
              },
              attrs: { "aria-hidden": "true" },
              on: {
                click: function ($event) {
                  return _vm.nextImage()
                },
              },
            }),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "content has-text-grey has-text-centered" },
      [
        _c(
          "span",
          { staticStyle: { opacity: "0" }, attrs: { icon: "icon is-large" } },
          [_c("i", { staticClass: "mdi mdi-spin mdi-loading mdi-36px" })]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "carousel-item has-background is-active" },
      [
        _c("img", {
          staticClass: "is-background",
          attrs: { src: "", alt: "", width: "800", height: "600" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }